import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sendFeedback: {
    description: 'Button label to open the feedback modal from a banner',
    defaultMessage: 'Send Feedback',
    id: 'i9BXUO',
  },
  defaultContent: {
    description: 'Default banner content when no custom content is provided',
    defaultMessage: 'We would love to hear what you think about this feature.',
    id: 'PtzEc8',
  },
});
